import React, { Fragment } from 'react';

import { FormFlex, FormBox, FormGroupLoader, RadioGroupLoader } from 'components/shared/form';

function Loader() {
  return (
    <Fragment>
      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="3.875rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={[1, 1, 1 / 3]}>
          <FormGroupLoader labelWidth="8.5rem" />
        </FormBox>
        <FormBox width={[1, 1, 1 / 3]}>
          <FormGroupLoader labelWidth="9.75rem" />
        </FormBox>
        <FormBox width={[1, 1, 1 / 3]}>
          <FormGroupLoader labelWidth="9.75rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="9.375rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="26.375rem" inputHeight="9.1875rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <RadioGroupLoader inline labelWidth="20rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <RadioGroupLoader inline labelWidth="20.8rem" />
        </FormBox>
      </FormFlex>
    </Fragment>
  );
}

export default Loader;
